import CustomizableAvatar from "../common/CustomizableAvatar";
import Smartlend from "../../assets/SMARTLEND.png";
import CustomButton from "../common/CustomButton";
import { Link } from "react-router-dom";
import Login from "./Login";

const SuccessfulPassword = () => {
  return (
    <div className="container mx-auto my-10  text-center  p-8">
      <CustomizableAvatar
        src={Smartlend}
        customClass={"flex justify-center py-4"}
      />
      <p className=" text-4xl font-medium p-7">Password reset successful!</p>
      <CustomButton
        className={
          "bg-indigo-500 text-slate-50 border rounded my-3 cursor-pointer hover:bg-indigo-600"
        }
      >
        <Link to={"/login"} element={<Login />} className="px-14">
          Login
        </Link>
      </CustomButton>
    </div>
  );
};
export default SuccessfulPassword;
